import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectSessionLanguage} from '../store/selectors';
import {SupportedLanguage} from '../models/supported-language.model';


@Injectable()
export class SessionLanguageInterceptor implements HttpInterceptor {
  private store = inject<Store<AppState>>(Store);


  sessionLanguage: SupportedLanguage;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const store = this.store;


    store
      .pipe(
        select(selectSessionLanguage)
      )
      .subscribe(sessionLanguage => this.sessionLanguage = sessionLanguage);

  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    const isGcsSignedUrl = req.url.startsWith('https://storage.googleapis.com/') || req.url.includes('.firebasestorage.app');

    if (this.sessionLanguage && !isGcsSignedUrl && (req.method == 'POST' || req.method == "PUT" || req.method == "DELETE") ) {
      const cloned = req.clone({
        body: {
          ...req.body,
          sessionLanguage: this.sessionLanguage
        }
      });
      return next.handle(cloned);
    }
    else {
      return next.handle(req);
    }

  }

}
